<template>
  <div class="Center">
    <div class="Img">
      <div class="wenzi">
        <p
          class="p1 wow animated bounceInUp"
          data-wow-duration="1s"
          data-wow-delay=".1s"
        >
          只为宠物智慧生活！
        </p>
        <p
          class="p2 wow animated bounceInUp"
          data-wow-duration="1.5s"
          data-wow-delay=".2s"
        >
          为全球宠物主提供智能、可持续、性价比高的产品和服务。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.Center {
  width: 100%;
  margin: 0 auto;
  .Img {
    background-image: url("../../assets/about/矩形 3 拷贝 9.png");
    width: 100%;
    height: 937px;
    min-width: 1440px;
    z-index: 0;
    background-position: center center;
    display: flex;
    justify-content: center;
    align-content: center;
    .wenzi {
      width: 809px;
      height: 112px;
      overflow: hidden;
      margin: 0 auto;
      padding-top: 399px;
      .p1 {
        width: 809px;
        /* margin: 0 auto; */
        text-align: center;
        height: 40px;
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        margin-bottom: 39px;
      }
      .p2 {
        width: 835px;
        height: 32px;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
}
</style>